export const routes = {
  home: '',
  leaderboardLanding: 'leaderboard',
  leaderboard: ':id',
  rules: 'rules',
  prizes: 'prizes',
  game: 'game',
  result: 'result'
};

Object.freeze(routes);
